/**
 * Generated runtime TestId mirror for frontend/src/pages/CertificationPolicies.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const CertificationPoliciesTestIds = {
  btnCreatePolicy: "btn-create-policy",
  certificationPoliciesList: "certification-policies-list",
  colConditions: "col-conditions",
  colFrequency: "col-frequency",
  colName: "col-name",
  colPriority: "col-priority",
  colStatus: "col-status",
  linkPolicy: (policy_id: string) => `link-policy-${policy_id}`,
  linkPolicyPrefix: () => "link-policy-" as TestIdPrefix,
  policyConditions: (policy_id: string) => `policy-conditions-${policy_id}`,
  policyConditionsPrefix: () => "policy-conditions-" as TestIdPrefix,
  policyDefault: (policy_id: string) => `policy-default-${policy_id}`,
  policyDefaultPrefix: () => "policy-default-" as TestIdPrefix,
  policyFrequency: (policy_id: string) => `policy-frequency-${policy_id}`,
  policyFrequencyPrefix: () => "policy-frequency-" as TestIdPrefix,
  policyName: (policy_id: string) => `policy-name-${policy_id}`,
  policyNamePrefix: () => "policy-name-" as TestIdPrefix,
  policyPriority: (policy_id: string) => `policy-priority-${policy_id}`,
  policyPriorityPrefix: () => "policy-priority-" as TestIdPrefix,
  policyRow: (policy_id: string) => `policy-row-${policy_id}`,
  policyRowPrefix: () => "policy-row-" as TestIdPrefix,
  policyScopeExpression: (policy_id: string) => `policy-scope-expression-${policy_id}`,
  policyScopeExpressionPrefix: () => "policy-scope-expression-" as TestIdPrefix,
  policyStatus: (policy_id: string) => `policy-status-${policy_id}`,
  policyStatusPrefix: () => "policy-status-" as TestIdPrefix
} as const;
